import { ContentWidth, TextWidth } from '@ta-interaktiv/react-disco-grid'
import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useElementSize, useUpdateEffect, useWindowSize } from 'usehooks-ts'

export const BaseImage = ({
  img,
  source,
  title,
}: {
  img: string
  source?: string
  title?: string
}) => {
  const [windowHeight, setWindowHeight] = useState(0)
  const windowSize = useWindowSize()

  useEffect(() => {
    setWindowHeight(windowSize.height)
  }, [])
  useEffect(() => {
    setWindowHeight(windowSize.height)
  }, [windowSize.width])

  return (
    <>
      <Container >
        <BGImage src={img} />
      </Container>
    
        <>
          {title && <Title>{title}</Title>}
          {source && <Source>{source}</Source>}
        </>
   
    </>
  )
}

const Container = styled.div.attrs({ className: 'Image' })`
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  overflow: hidden;
  margin-top: 30px;
`

const Source = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  text-align: left;
  line-height: 21px;  width: 100%;
`
const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 15px;
  color: var(--text-color);
  text-align: left;
  width: 100%;
  line-height: 21px;
`

const BGImage = styled.img`
  max-width: 100%;
`
